import {ref} from "@vue/composition-api";
import {department} from "@/views/useDepartment";
import DateUtil from "@/utils/dateUtil";
import RapidTestService from "@/api/rapidTest";
import MessageService from "@/components/Message";

export const detailLoading = ref(false);
export const detailData = ref([]);
export const reportDate = ref('');

export const getDetailData = async ({date}) => {

    const queryParam = {department: department.value, date: DateUtil.format(date, 'YYYY-MM-DD')};
    detailLoading.value = true;
    reportDate.value = DateUtil.getReportDate(date);
    const dailyRapidTests = await RapidTestService.reportedRapidTestWithDept(queryParam);
    detailData.value = dailyRapidTests.map(rt => ({...rt, reportDate: DateUtil.format(rt.createAt, 'YYYY-MM-DD')}));
    detailLoading.value = false;
}

export const openDetails = row => getDetailData(row).catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
